import { render, staticRenderFns } from "./FeaturesListItemRemove.vue?vue&type=template&id=6c1e1b70&scoped=true&"
import script from "./FeaturesListItemRemove.vue?vue&type=script&lang=js&"
export * from "./FeaturesListItemRemove.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesListItemRemove.vue?vue&type=style&index=0&id=6c1e1b70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e1b70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFlex,VIcon})
